"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateSwitch = exports.serializeSwitch = void 0;
const serializeSwitch = (item) => {
    return typeof item.data.switchOn === "boolean" ? `${item.data.switchOn}` : "";
};
exports.serializeSwitch = serializeSwitch;
const validateSwitch = (item) => {
    if (!item.required || item.data.switchOn) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Must be switched on." } };
};
exports.validateSwitch = validateSwitch;
//# sourceMappingURL=switch.js.map